import ShareList from './share-list/share-list.vue';
import AddShare from './add-share/add-share.vue';
import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'share-item-modal',
  components: {
    ShareList,
    AddShare,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    shareItem: {
      type: Object,
      required: true,
    },
    shareTitle: {
      type: String,
      default: 'Share',
    },
  },
  data: () => ({
    shares: [],
  }),
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleRevoke(uuid) {
      this.shares = this.shares.filter(item => item.uuid !== uuid);
    },
    getShares() {
      const accountId = this.$store.getters['account/getActiveAccount'].uuid;
      return API.get(
        // eslint-disable-next-line max-len
        `${ENDPOINTS.GET_SHARE_USERS}/${this.shareItem.uuid}?accountID=${accountId}&type=${this.shareItem.type}`,
      )
        .then((res) => {
          this.shares = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    shareItem: {
      handler() {
        this.shares = [];
        this.getShares();
      },
      immediate: true,
    },
  },
};
